export enum ANALYTIC_USER_EVENTS {
  TRAVEL_MODERATED_APPROVED = "TRAVEL_MODERATED_APPROVED",
  TRAVEL_UPLOADED = "TRAVEL_UPLOADED",
  CAMPAIGN_PARTICIPANT_UPDATED = "CAMPAIGN_PARTICIPANT_UPDATED",
  FAN_UNSUBSCRIBE = "FAN_UNSUBSCRIBE",
}
